import './product-slider.scss';
import Swiper from 'swiper';
import { A11y, Navigation, Pagination, Keyboard, EffectFade } from 'swiper/modules';
import { scrollPageTo } from '../../utilities/js/scroll-to';

class ProductSlider {
    constructor ($productSlider, settings) {
        this.$productSlider = $productSlider;

        this.$slider = this.$productSlider.querySelector('[data-product-slider="slider"]');
        this.slider = undefined;

        this.$paginations = this.$productSlider.querySelectorAll('[data-product-slider="pagination"]');

        this.$counter = this.$productSlider.querySelector('[data-product-slider="counter"]');

        this.$rte = this.$productSlider.querySelector('[data-product-slider="rte"]');
    }

    initialize () {
        if (this.$slider && this.$counter) {
            this.bindEvents();
            this.initSlider();
            this.updatePagination();
            this.updateCounterPosition();
            this.updateCounterValue();
        }
    }

    bindEvents () {
        document.addEventListener('sizeMobile', () => {
            this.destroySlider();
            this.initSlider();
        });

        document.addEventListener('sizeTablet', () => {
            this.destroySlider();
            this.initSlider();
        });
        document.addEventListener('sizeDesktop', () => {
            this.destroySlider();
            this.initSlider();
        });

        document.addEventListener('sizeWide', () => {
            this.destroySlider();
            this.initSlider();
        });

        const addPaginationEvents = ($pagination) => {
            $pagination.addEventListener('click', () => {
                this.goToClickedSlide($pagination);
            });
        };

        for (let i = 0; i < this.$paginations.length; i++) {
            const $pagination = this.$paginations[i];
            addPaginationEvents($pagination);
        }

        if (this.$rte) {
            const $link = this.$rte.querySelector('a');

            if ($link) {
                $link.addEventListener('click', () => {
                    this.scrollToContactForm($link);
                });
            }
        }
    }

    initSlider () {
        const sliderConfig = {
            modules: [A11y, Navigation, Pagination, Keyboard, EffectFade],
            a11y: true,
            keyboard: true,
            simulateTouch: false,
            resistanceRatio: 0,
            pagination: {
                el: this.$productSlider.querySelector('[data-product-slider="fraction"]'),
                type: 'fraction'
            },
            navigation: {
                prevEl: this.$productSlider.querySelector('[data-product-slider="prev"]'),
                nextEl: this.$productSlider.querySelector('[data-product-slider="next"]')
            }
        };

        if (window.innerWidth >= window.OPTIONS.breakpoints.m) {
            sliderConfig.autoHeight = true;
            sliderConfig.effect = 'fade';
            sliderConfig.fadeEffect = {
                crossFade: true
            };
        }

        this.slider = new Swiper(this.$slider, sliderConfig);

        this.slider.on('slideChange', () => {
            this.updatePagination();
            this.updateCounterPosition();
            this.updateCounterValue();
        });
    }

    destroySlider () {
        if (this.slider) {
            this.slider.destroy(true, true);
        }
    }

    goToClickedSlide ($pagination) {
        const index = parseInt($pagination.getAttribute('value'));
        this.slider.slideTo(index);
    }

    updatePagination () {
        const activeSlideIndex = this.slider.activeIndex;

        for (let i = 0; i < this.$paginations.length; i++) {
            const $pagination = this.$paginations[i];
            const paginationIndex = parseInt($pagination.getAttribute('value'));

            if (paginationIndex === activeSlideIndex) {
                $pagination.classList.add('product-slider__pagination-image--active');
            } else {
                $pagination.classList.remove('product-slider__pagination-image--active');
            }
        }
    }

    updateCounterPosition () {
        const numberOfSlides = this.slider.slides.length;
        const activeSlide = this.slider.activeIndex;

        const offset = 100 / (numberOfSlides - 1) * activeSlide;

        if (offset === 100) {
            const counterWidth = this.$counter.getBoundingClientRect().width;
            this.$counter.style.left = `calc(${offset}% - ${counterWidth}px)`;
        } else {
            this.$counter.style.left = `${offset}%`;
        }
    }

    updateCounterValue () {
        let activeSlide = this.slider.activeIndex + 1;

        if (activeSlide < 9) {
            activeSlide = '0' + activeSlide;
        }

        this.$counter.textContent = activeSlide;
    }

    scrollToContactForm ($link) {
        const contactFormId = $link.getAttribute('href');
        const $contactForm = document.querySelector(contactFormId);

        if ($contactForm) {
            scrollPageTo($contactForm);
        }
    }
}

export { ProductSlider };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-product-slider="root"]');
        $$roots.forEach($root => {
            const $rootAPI = new ProductSlider($root);
            $rootAPI.initialize();
        });
    }
});
